// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3M2Tj","selected":"Chip_selected__1fkRJ"};